var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailsent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 167.002,
    height: 159.328,
    viewBox: "0 0 167.002 159.328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5395",
    "data-name": "Group 5395",
    transform: "translate(-125.575 -95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5393",
    "data-name": "Group 5393",
    transform: "translate(125.575 111.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4845",
    "data-name": "Path 4845",
    d: "M151.142,270.662s.216,29.793,27.85,39.94c0,0,21.589,9.283,43.179-12.738,0,0,21.157,21.373,41.02-5.829,0,0,17.056,8.852,26.987-9.715,0,0,7.988-15.976-5.181-25.907,0,0,8.2-14.465.432-30.009,0,0-5.181-11.874-18.351-15.112,0,0-1.079-29.145-27.634-39.508,0,0-39.724-15.328-55.7,29.361,0,0-28.066-10.363-38.861,23.532,0,0-23.748,3.454-18.567,29.793C126.315,254.471,130.848,272.821,151.142,270.662Z",
    transform: "translate(-125.575 -169.246)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4846",
    "data-name": "Path 4846",
    d: "M178.648,369.943l54.837,39.292L272.993,368H178Z",
    transform: "translate(-166.682 -325.09)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4847",
    "data-name": "Path 4847",
    d: "M275.918,430.017h-89.7a4.933,4.933,0,0,1-4.8-3.771L166.85,366.618a4.944,4.944,0,0,1,4.8-6.118h90.281a4.925,4.925,0,0,1,4.814,3.815l13.985,59.629a4.944,4.944,0,0,1-4.814,6.073ZM171.653,363.738A1.706,1.706,0,0,0,170,365.849l14.567,59.629a1.7,1.7,0,0,0,1.657,1.3h89.7a1.706,1.706,0,0,0,1.661-2.1l-13.985-59.629a1.7,1.7,0,0,0-1.661-1.316Z",
    transform: "translate(-157.827 -319.21)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4848",
    "data-name": "Path 4848",
    d: "M229.725,408.642a5.412,5.412,0,0,1-3.155-1.007l-53.434-38.226,1.884-2.634L228.454,405a2.21,2.21,0,0,0,2.872-.272l36.572-38.4,2.345,2.233-36.572,38.4A5.443,5.443,0,0,1,229.725,408.642Z",
    transform: "translate(-162.868 -323.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1",
    "data-name": "Line 1",
    d: "M-3.921,19.409a1.076,1.076,0,0,1-.755-.308,1.079,1.079,0,0,1-.016-1.527l21.8-22.25a1.079,1.079,0,0,1,1.527-.016,1.079,1.079,0,0,1,.016,1.527l-21.8,22.25A1.076,1.076,0,0,1-3.921,19.409Z",
    transform: "translate(37.263 80.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    "data-name": "Line 2",
    d: "M28.462,20.475a1.074,1.074,0,0,1-.63-.2L-4.552-3.045A1.079,1.079,0,0,1-4.8-4.552,1.079,1.079,0,0,1-3.29-4.8L29.094,18.52a1.08,1.08,0,0,1-.632,1.956Z",
    transform: "translate(80.007 80.078)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4849",
    "data-name": "Path 4849",
    d: "M301.526,469.6H217.342a4.1,4.1,0,0,1-4-3.15l-11.316-47.117a1.079,1.079,0,1,1,2.1-.5l11.316,47.117a1.945,1.945,0,0,0,1.9,1.5h84.184a1.079,1.079,0,1,1,0,2.159Z",
    transform: "translate(-185.5 -364.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    "data-name": "Line 3",
    d: "M12.567-3.409H-4.7A1.3,1.3,0,0,1-6-4.7,1.3,1.3,0,0,1-4.7-6H12.567a1.3,1.3,0,0,1,1.3,1.3A1.3,1.3,0,0,1,12.567-3.409Z",
    transform: "translate(129.798 104.934)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_4",
    "data-name": "Line 4",
    d: "M5.442-3.409H-4.7A1.3,1.3,0,0,1-6-4.7,1.3,1.3,0,0,1-4.7-6H5.442a1.3,1.3,0,0,1,1.3,1.3A1.3,1.3,0,0,1,5.442-3.409Z",
    transform: "translate(127.315 93.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_5",
    "data-name": "Line 5",
    d: "M6.09-3.409H-4.7A1.3,1.3,0,0,1-6-4.7,1.3,1.3,0,0,1-4.7-6H6.09a1.3,1.3,0,0,1,1.3,1.3A1.3,1.3,0,0,1,6.09-3.409Z",
    transform: "translate(123.429 68.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_6",
    "data-name": "Line 6",
    d: "M12.567-3.409H-4.7A1.3,1.3,0,0,1-6-4.7,1.3,1.3,0,0,1-4.7-6H12.567a1.3,1.3,0,0,1,1.3,1.3A1.3,1.3,0,0,1,12.567-3.409Z",
    transform: "translate(119.004 56.574)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5394",
    "data-name": "Group 5394",
    transform: "translate(184.174 95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4850",
    "data-name": "Path 4850",
    d: "M403,102.216l6.477,17.056.864-4.1.271-5.616,10.524-.429L403,102Z",
    transform: "translate(-401.705 -100.489)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4851",
    "data-name": "Path 4851",
    d: "M424.305,164.929a.864.864,0,0,1-.8-.529l-11.442-27.2a.864.864,0,1,1,1.592-.67l10.643,25.3,2.445-5.868a.864.864,0,1,1,1.594.664L425.1,164.4a.864.864,0,0,1-.8.531Z",
    transform: "translate(-408.761 -127.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4852",
    "data-name": "Path 4852",
    d: "M486.862,163.328a.864.864,0,0,1-.8-1.2l1.727-4.1a.864.864,0,0,1,.485-.471l13.15-5.072-6.492-2.83a.864.864,0,1,1,.69-1.583l8.42,3.67a.864.864,0,0,1-.034,1.6l-14.77,5.7-1.585,3.764A.864.864,0,0,1,486.862,163.328Z",
    transform: "translate(-466.785 -136.557)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4853",
    "data-name": "Path 4853",
    d: "M422.475,107.09a.861.861,0,0,1-.335-.068l-22.774-9.589,1.467,3.96a.864.864,0,0,1-1.62.6l-2.159-5.829a.864.864,0,0,1,1.145-1.1L422.81,105.43a.864.864,0,0,1-.335,1.66Z",
    transform: "translate(-397 -95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_7",
    "data-name": "Line 7",
    d: "M7.874,8.954a.861.861,0,0,1-.617-.259L-3.753-2.532a.864.864,0,0,1,.012-1.221.864.864,0,0,1,1.221.012L8.491,7.485a.864.864,0,0,1-.616,1.468Z",
    transform: "translate(4 4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_8",
    "data-name": "Line 8",
    d: "M4.539,5.513a.861.861,0,0,1-.615-.257L-3.751-2.53a.864.864,0,0,1,.009-1.221.864.864,0,0,1,1.221.009L5.154,4.044a.864.864,0,0,1-.615,1.47Z",
    transform: "translate(17.169 17.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4854",
    "data-name": "Path 4854",
    d: "M433.864,145.155a.864.864,0,0,1-.864-.864V132.569a.864.864,0,0,1,.868-.864l11.226.064a.864.864,0,1,1-.01,1.727l-10.358-.059v10.853A.864.864,0,0,1,433.864,145.155Z",
    transform: "translate(-425.228 -123.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_9",
    "data-name": "Line 9",
    d: "M1.4,2.261a.861.861,0,0,1-.611-.253L-3.747-2.526a.864.864,0,0,1,0-1.221.864.864,0,0,1,1.221,0L2.008.787A.864.864,0,0,1,1.4,2.261Z",
    transform: "translate(32.066 32.282)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_10",
    "data-name": "Line 10",
    d: "M1.4,2.261a.861.861,0,0,1-.611-.253L-3.747-2.526a.864.864,0,0,1,0-1.221.864.864,0,0,1,1.221,0L2.008.787A.864.864,0,0,1,1.4,2.261Z",
    transform: "translate(26.453 34.225)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_11",
    "data-name": "Line 11",
    d: "M1.4,2.261a.861.861,0,0,1-.611-.253L-3.747-2.526a.864.864,0,0,1,0-1.221.864.864,0,0,1,1.221,0L2.008.787A.864.864,0,0,1,1.4,2.261Z",
    transform: "translate(34.009 26.669)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4855",
    "data-name": "Path 4855",
    d: "M592.96,316.964q-.55,0-1.065-.01a.864.864,0,0,1,.031-1.727c.788.014,1.644.013,2.552-.011a.864.864,0,0,1,.046,1.727C593.983,316.957,593.461,316.964,592.96,316.964Zm-3.638-.114-.055,0c-1.651-.1-2.642-.242-2.642-.242a.864.864,0,0,1,.236-1.711c.017,0,.958.13,2.515.229a.864.864,0,0,1-.054,1.725Zm7.765-.036a.864.864,0,0,1-.063-1.725c.822-.061,1.67-.143,2.533-.252a.864.864,0,0,1,.216,1.714c-.894.113-1.771.2-2.622.261Zm5.138-.654a.864.864,0,0,1-.157-1.713c.822-.153,1.649-.333,2.474-.544a.864.864,0,1,1,.428,1.673c-.862.221-1.727.409-2.586.569A.871.871,0,0,1,602.224,316.16Zm5.014-1.293a.864.864,0,0,1-.278-1.681c.792-.27,1.574-.573,2.339-.914a.864.864,0,1,1,.7,1.578c-.813.362-1.644.685-2.485.971A.862.862,0,0,1,607.238,314.867Zm4.721-2.118a.864.864,0,0,1-.434-1.611,20.157,20.157,0,0,0,2.068-1.373.864.864,0,0,1,1.044,1.376,21.9,21.9,0,0,1-2.246,1.491A.86.86,0,0,1,611.959,312.75Zm4.106-3.135a.864.864,0,0,1-.613-1.472,16.379,16.379,0,0,0,1.6-1.869.864.864,0,0,1,1.395,1.019,18.116,18.116,0,0,1-1.766,2.067A.861.861,0,0,1,616.064,309.614Zm3.042-4.168a.864.864,0,0,1-.766-1.261,16.954,16.954,0,0,0,.968-2.264.864.864,0,0,1,1.633.563,18.69,18.69,0,0,1-1.067,2.5A.864.864,0,0,1,619.107,305.446Zm1.7-4.879a.864.864,0,0,1-.847-1.036,21.983,21.983,0,0,0,.353-2.465.864.864,0,1,1,1.721.149,23.7,23.7,0,0,1-.381,2.66A.864.864,0,0,1,620.8,300.568Zm.461-5.15a.864.864,0,0,1-.863-.855q-.012-1.212-.131-2.517a.864.864,0,0,1,1.72-.158q.127,1.378.138,2.657a.864.864,0,0,1-.855.872Zm-.467-5.16a.864.864,0,0,1-.851-.721q-.22-1.309-.527-2.451a.864.864,0,1,1,1.668-.448q.327,1.22.563,2.613a.864.864,0,0,1-.853,1.007Zm-1.366-4.986a.864.864,0,0,1-.8-.535,14.458,14.458,0,0,0-1.11-2.174.864.864,0,0,1,1.463-.919,16.2,16.2,0,0,1,1.244,2.434.864.864,0,0,1-.8,1.193Zm-2.766-4.344a.861.861,0,0,1-.622-.264,11.155,11.155,0,0,0-1.844-1.536.864.864,0,0,1,.957-1.437,12.886,12.886,0,0,1,2.129,1.774.864.864,0,0,1-.621,1.463Zm-4.269-2.873a.861.861,0,0,1-.336-.069,17.779,17.779,0,0,0-2.337-.791.864.864,0,1,1,.445-1.669,19.508,19.508,0,0,1,2.565.87.864.864,0,0,1-.337,1.659Zm-4.983-1.37a.867.867,0,0,1-.143-.012c-.813-.136-1.652-.245-2.516-.335a.864.864,0,1,1,.18-1.718c.9.094,1.774.208,2.62.349a.864.864,0,0,1-.141,1.715Zm-5.149-.562-.061,0c-.84-.058-1.7-.107-2.572-.154a.864.864,0,0,1,.092-1.725c.884.047,1.751.1,2.6.156a.864.864,0,0,1-.059,1.725Zm-5.173-.288h-.046c-.854-.044-1.72-.092-2.6-.147a.864.864,0,1,1,.109-1.724c.87.055,1.73.1,2.577.146a.864.864,0,0,1-.044,1.726Zm-5.17-.336c-.025,0-.049,0-.074,0q-1.291-.11-2.6-.26a.864.864,0,1,1,.2-1.716q1.286.15,2.551.255a.864.864,0,0,1-.072,1.724Zm-5.145-.606a.871.871,0,0,1-.135-.01q-1.288-.2-2.589-.466a.864.864,0,1,1,.347-1.692q1.261.258,2.51.452a.864.864,0,0,1-.133,1.717Zm-5.074-1.046a.865.865,0,0,1-.219-.028q-1.265-.331-2.535-.742a.864.864,0,0,1,.535-1.642q1.22.4,2.437.714a.864.864,0,0,1-.218,1.7Zm-4.923-1.607a.861.861,0,0,1-.319-.061q-1.214-.483-2.426-1.059a.864.864,0,0,1,.743-1.559q1.159.553,2.321,1.013a.864.864,0,0,1-.319,1.666Zm-4.674-2.229a.86.86,0,0,1-.423-.111q-1.135-.639-2.263-1.377a.864.864,0,0,1,.947-1.445q1.078.707,2.164,1.316a.864.864,0,0,1-.424,1.616Zm-4.331-2.837a.859.859,0,0,1-.519-.174q-1.035-.78-2.059-1.659a.864.864,0,0,1,1.125-1.31q.982.843,1.974,1.59a.864.864,0,0,1-.521,1.553Zm-3.93-3.372a.861.861,0,0,1-.6-.243q-.926-.9-1.84-1.888a.864.864,0,1,1,1.27-1.171q.88.955,1.773,1.819a.864.864,0,0,1-.6,1.484Zm-3.617-3.709a.861.861,0,0,1-.611-.253l-.365-.365a.864.864,0,0,1,1.221-1.221l.365.365a.864.864,0,0,1-.611,1.474Z",
    transform: "translate(-524.025 -222.809)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailsent);
export default __webpack_public_path__ + "static/media/emailsent.9a6137b7a7b278b4749c8621fc0c5dac.svg";
export { ForwardRef as ReactComponent };